export default __webpack_public_path__ + "static/media/login.f558a89e.svg";